import * as s from "../grid/schema";
import {isHexTextColor, type HexTextColor} from "./textColor";

export const TEXT_COLOR_FIELDS = ["title", "subtitle", "subtitle2", "subtitle3", "name", "name2", "name3", "name4", "name5", "name6", "position", "position2", "time", "date", "badge", "productName", "features", "eap", "link", "link2", "link3", "version", "cursorLabel", "tags", "gdnTags"] as const;
export type TextColorField = typeof TEXT_COLOR_FIELDS[number];
export type FieldColors = Partial<Record<TextColorField, HexTextColor>>;
export type ElementColors = {buttonFill?: HexTextColor};

export const hexColorSchema: s.Validator<HexTextColor> = (value, path) => {
  if (!isHexTextColor(value)) s.fail(path, "Expected #rrggbb color");
  return value as HexTextColor;
};
function colorsSchema<T>(keys: readonly string[]): s.Validator<T> {
  return (value, path = "colors") => {
    const record = s.object(value, path);
    for (const [key, color] of Object.entries(record)) {
      if (!keys.includes(key)) s.fail(`${path}.${key}`, "Unknown color target");
      hexColorSchema(color, `${path}.${key}`);
    }
    return record as T;
  };
}
export const fieldColorsSchema = colorsSchema<FieldColors>(TEXT_COLOR_FIELDS);
export const elementColorsSchema = colorsSchema<ElementColors>(["buttonFill"]);

export function sceneColorRecords<T>(value: unknown, validate: s.Validator<T>): Record<string, T> {
  return value === undefined ? {} : s.dictionary(validate)(value, "scene.colors");
}

export function textColorField(type: string): TextColorField | null {
  const aliases = {"product-name": "productName", editabletag: "tags", "gdn-tag": "gdnTags", "gdn-button": "badge"} as const;
  if (Object.hasOwn(aliases, type)) return aliases[type as keyof typeof aliases];
  return TEXT_COLOR_FIELDS.includes(type as TextColorField) ? type as TextColorField : null;
}
